<div class="row device text-center">
  <div class="col-12">
    <div class="row preview-outer text-center">
      <div class="col-12">
        <img class="img border mb-2" [src]="image.name" alt="..." *ngFor="let image of circularPreviewData.images;">
      </div>
    </div>

    <div class="circular-date text-muted mt-2">
      {{ circularPreviewData?.start_date | date : 'MMM d, y' : 'UTC' }} - {{ circularPreviewData?.end_date | date : 'MMM d, y' : 'UTC' }}
    </div>
  </div>
</div>

